import React from "react";

import "./style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  return (
    <>
      <section className="section sns">
        <div className="inner_section">
          <h2 className="ttl_h2">
            <span className="en en_green">SNS</span>
            <br />
            各種SNSで最新情報発信中!
          </h2>

          <div className="wrap_sns_contents">
            <div className="sns_contents sns_contents_twitter">
              <a
                href="https://mobile.twitter.com/shisokanko"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://shiso.or.jp/wpapp/wp-content/themes/shiso2022ver2/images/top/bg_twitter_pc.png"
                  alt=""
                  className="img_switch"
                />
                <span className="sns_name">Twitter</span>
              </a>
            </div>
            <div className="sns_contents sns_contents_facebook">
              <a
                href="https://www.facebook.com/shisou.kanko"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://shiso.or.jp/wpapp/wp-content/themes/shiso2022ver2/images/top/bg_facebook_pc.png"
                  alt=""
                  className="img_switch"
                />
                <span className="sns_name">Facebook</span>
              </a>
            </div>

            <div className="sns_contents sns_contents_insta">
              <a
                href="https://www.instagram.com/morinavi.shiso/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://shiso.or.jp/wpapp/wp-content/themes/shiso2022ver2/images/top/bg_insta_pc.png"
                  alt=""
                  className="img_switch"
                />
                <span className="sns_name">Instagram</span>
              </a>
            </div>

            <div className="sns_contents sns_contents_youtube">
              <a
                href="https://www.youtube.com/channel/UClxA0zNmRWMsumWqz4navkg/featured"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://shiso.or.jp/wpapp/wp-content/themes/shiso2022ver2/images/top/bg_youtube01_pc.png"
                  alt=""
                  className="img_switch"
                />
                <span className="sns_text">
                  しそう森林王国
                  <br />
                  観光協会
                </span>
                <span className="sns_name">YouTube</span>
              </a>
            </div>

            <div className="sns_contents sns_contents_youtube">
              <a
                href="https://www.youtube.com/channel/UCmdQfRr6CdXZnD6En2g4PnA"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://shiso.or.jp/wpapp/wp-content/themes/shiso2022ver2/images/top/bg_youtube02_pc.png"
                  alt=""
                  className="img_switch"
                />
                <span className="sns_text">
                  宍粟市
                  <br />
                  公式
                </span>
                <span className="sns_name">YouTube</span>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="wrap_bnr_link">
        <ul className="ul_bnr_link">
          <li>
            <a
              href="https://www.city.shiso.lg.jp/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://shiso.or.jp/wpapp/wp-content/themes/shiso2022ver2/images/top/bnr_link01_pc.jpg"
                alt=""
                className="img_switch"
              />
            </a>
          </li>
          <li>
            <a
              href="https://www.kuniminomori.jp/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://shiso.or.jp/wpapp/wp-content/themes/shiso2022ver2/images/top/bnr_link02_pc.jpg"
                alt=""
                className="img_switch"
              />
            </a>
          </li>

          <li>
            <a
              href="https://shiso-ryouin.com/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://shiso.or.jp/wpapp/wp-content/themes/shiso2022ver2/images/top/bnr_link04_pc.jpg"
                alt=""
                className="img_switch"
              />
            </a>
          </li>
          <li>
            <a
              href="https://webshop.montbell.jp/goods/?c=4"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://shiso.or.jp/wpapp/wp-content/themes/shiso2022ver2/images/top/bnr_link05_pc.png"
                alt="モンベルクラブ会員優待エリアはこちら"
                className="img_switch"
              />
            </a>
          </li>
        </ul>
      </div>
      <footer id="footer">
        <div className="wrap_footer">
          <p className="footer_logo">
            <img
              src="https://shiso.or.jp/wpapp/wp-content/themes/shiso2022ver2/images/footer_logo_pc.png"
              alt=""
              className="img_switch"
            />
            公益財団法人しそう森林王国観光協会
          </p>

          <div className="footer_left">
            <div className="footer_info">
              <address>
                〒671-2558 兵庫県宍粟市山崎町上比地374
                <br />
                (兵庫県立国見の森公園内)
                <p className="footer_tel">
                  TEL：0790-64-0923 FAX：0790-64-5011
                </p>
              </address>

              <div className="footer-text-container">
                <p className="footer-text">
                  <a href="https://shiso.or.jp/privacy_policy">
                    プライバシーポリシー
                  </a>
                </p>
                <p className="footer-text ms-3">
                  <a href="https://shiso.or.jp/tradelaw">利用規約</a>
                </p>
              </div>
            </div>
          </div>

          <div className="footer_right">
            <p className="btn_to_contact btn bg-white text-primary fw-bold mb-4 mb-lg-0 me-lg-4">
              <a href="https://shiso.or.jp/contact">
                <FontAwesomeIcon icon={faEnvelope} />
                お問合せ
              </a>
            </p>

            <p className="btn_to_access btn btn-primary fw-bold">
              <a
                href="https://goo.gl/maps/FCi6wQp7Cwkg54kt9"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faMapMarkerAlt} />
                アクセスマップ
              </a>
            </p>
          </div>
        </div>

        <p className="copyright">© 2022 (公財)しそう森林王国観光協会. </p>
      </footer>
    </>
  );
};

export default Footer;
